<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser"></left-panel>  
      </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "Enteryour4digitPIN" | translate }}
                    </div>
                    <!-- <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "PleaseAuthenticate4DigitPIN" | translate }}
                    </div> -->
                    <br>
                    <span class="color-primary"  *ngIf="this.Screen == 'Reissue'">
                        {{this.maskemail}}
                    </span>
                    <span class="color-primary" *ngIf="this.Screen != 'Reissue'">
                        {{this.common.maskMobileNumber(this.Mobile)|translate}}
                    </span>
                    
                </grid-col>
                <grid-col col="12">
                    <div class="mt-50 form-group text-align-center">
                        <ng-otp-input (onInputChange)="onOtpChange($event)" (keydown)="onKeyDown($event)"
                            allowNumbersOnly='true' [config]="{length:6,allowNumbersOnly:true}"></ng-otp-input>
                        <!-- <input type="text" mask="9999" placeholder="Pin"  [(ngModel)]="otp"> -->
                    </div>
                    <grid-row class="justify-content-center align-item-center mt-50">
                        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
                          <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="ResendOtp()">
                            <div class="font-600 font-size-12px color-primary letter-spacing-1">
                              {{ "Resend" | translate }}
                            </div>
                          </div>
                        </grid-col>
                        <grid-col col="auto" *ngIf="OptTimerbtnShow">
                          <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                            <div class="font-600 font-size-12px color-primary letter-spacing-1">
                              {{ "Resend" | translate }}
                              <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                            </div>
                          </div>
                        </grid-col>
                    
                      </grid-row>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mt-50">
                        <grid-col col="auto">
                            <div class="mt-15">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </div>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft" [disabled]="this.otp == undefined || this.otp == '' || this.otp == null  || this.otp.length &lt; 6" (click)="VerifySMSOTPSetLimit()">
                                {{ "Next" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>